<template>
	<v-col id="store_detail_nav" class="ma-0 pa-0" cols="2">
    <v-row class="ma-0 pa-3 pt-5 pb-5" justify="space-between" align="center">
      <v-col class="ma-0 pa-0" cols="10" align-self="center" style="text-align:start">
        {{storeName}}
      </v-col>
      <!-- <v-col class="ma-0 pa-0" cols="2"
        v-if="authorities.ADD_STORE_GROUP">
        <v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn id="back_clean_btn" class="ma-0 pa-0"
							width="auto" height="2rem" v-bind="attrs" v-on="on">
							<v-img height="2rem" width="2rem" class="ma-0 pa-0"
								src="@/assets/images/more_black.png"></v-img>
						</v-btn>
					</template>
					<v-list class="ma-0 pa-0" dense>
						<v-list-item>
							<v-list-item-title align="left"
								style="color:#707070;">{{ tsc('addToStoreGroup') }}</v-list-item-title>
						</v-list-item>
						<v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
						<v-list-item v-for="(item, index) in storeGroupData" :key="index">
							<v-list-item-title align="left" @click="addToGroup(item)">{{ item.groupName }}</v-list-item-title>
						</v-list-item>
						<v-divider id="middle_divider" class="ma-0 pa-0"></v-divider>
						<v-list-item @click="goStoreGroup()">
							<v-list-item-title align="left">{{ tsc('createAndAddGroup') }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
      </v-col> -->
    </v-row>
    <v-row class="ma-0 pa-0 pb-10">
      <v-col class="ma-0 pa-0" cols="12">
        <v-list dense class="ma-0 pa-0" id="nav_list">
          <template v-for="item, index in navItems">
            <v-list-item class="ma-0 pa-0" :key="item.name">
              <v-list-item-content align="left" class="ma-0 pa-3 pt-2 pb-2 pr-1"
                id="menu_item" 
                :class="{'current_route': currentRoute == item.name}"
                @click="goPush(item.path)">
                <v-list-item-title style="font-size:0.8rem;">
                  <v-row class="ma-0 pa-0" align="center" justify="space-between">
                    <v-row class="ma-0 pa-1 pl-3" align="center">
                      <v-img max-height="1.25rem" max-width="1rem" class="ma-0 pa-0 mr-2"
                        :src="require(`@/assets/images/${item.icon}.png`)"
                      ></v-img>
                      <v-col class="ma-0 pa-0" cols="auto">
                        {{ item.name }}
                      </v-col>
                    </v-row>
                    <v-img max-height="1.5rem" max-width="1.25rem" class="ma-0 pa-0 mr-2"
                      v-if="index == 3"
                      src="@/assets/images/plus_round.png"
                    ></v-img>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-col>
    </v-row>
    <v-row class="ma-0 pa-0 pt-15 pl-3 pr-3" justify="center">
      <v-col class="ma-0 pa-0" id="camera_box" cols="12">
        <v-row class="ma-0 pa-2" justify="space-around">
          <v-col class="ma-0 pa-0" cols="5">
            <v-row class="ma-0 pa-0" id="camera_text_big" justify="center">{{cameraCount.uas}}</v-row>
            <v-row class="ma-0 pa-0" id="camera_text_small" justify="center">{{tsc('AiCamera')}}</v-row>
          </v-col>
          <v-col class="ma-0 pa-0" cols="auto" align-self="center">
            <v-divider id="camera_divider" vertical></v-divider>
          </v-col>
          <v-col class="ma-0 pa-0" cols="5">
            <v-row class="ma-0 pa-0" id="camera_text_big" justify="center">{{cameraCount.uac}}</v-row>
            <v-row class="ma-0 pa-0" id="camera_text_small" justify="center">{{tsc('cctvCamera')}}</v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- <v-row class="ma-0 pa-0 pt-5 pl-3">
      {{tsc('collaborativeService')}}
    </v-row>
    <v-row class="ma-0 pa-0 pt-5 pl-3 pr-3" justify="center">
      <v-col class="ma-0 pa-0" cols="12">
        <v-row class="ma-0 pa-0" justify="space-around">
          <v-col class="ma-0 pa-0 mb-3" cols="4" align="center"
            v-for="(item, index) in userSubscribedService" :key="index">
            <v-row class="ma-0 pa-0" justify="center">
              <v-img max-height="3rem" max-width="3rem" class="ma-0 pa-0"
                :src="item.serviceLogoUrl">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-skeleton-loader :boilerplate="false" elevation="0" dark 
                      type="image" width="3rem" height="3rem"
                    ></v-skeleton-loader>
                  </v-row>
                </template>  
              </v-img>
            </v-row>
            <v-row id="info_text_small" class="ma-0 pa-0 pt-1" justify="center">
              {{item.serviceName}}
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row> -->
    <v-row class="ma-0 pa-3 pt-15 pb-5" id="info_text_small">
      <v-col class="ma-0 pa-0" cols="auto" id="info_text_right">
        {{tsc('address')}} :
      </v-col>
      <v-col class="ma-0 pa-0" cols="auto" id="info_text_left">
        {{storeData.customerAddress1}} <br> {{storeData.customerAddress2}} <br> {{storeData.customerAddress3}}
      </v-col>
    </v-row>
    <v-row class="ma-0 pa-0 pl-3 pr-3 pb-2" id="info_text_small">
      <v-col class="ma-0 pa-0" cols="auto" id="info_text_right">
        {{tsc('phone')}} :
      </v-col>
      <v-col class="ma-0 pa-0" cols="auto" id="info_text_left">
        {{storeData.customerTel}}
      </v-col>
    </v-row>
    <v-row class="ma-0 pa-0 pl-3 pr-3" id="info_text_small">
      <v-col class="ma-0 pa-0" cols="auto" id="info_text_right">
        {{tsc('administrator')}} :
      </v-col>
      <v-col class="ma-0 pa-0" cols="auto" id="info_text_left">
        {{storeData.customerName}}
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import mixin from '@/mixin';
export default {
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
    authorities: {},
		unisCustomerCd: '',
    currentRoute: '',
    userSubscribedService: [],
    storeData: {},
		navItems: [
      {
        name: '自店舗分析',
        path: '/store-search/store-analyze',
        icon: 'all_store',
      },
      // {
      //   name: '他店舗分析',
      //   path: '/store-search/other-store',
      //   icon: 'store_group',
      // },
      {
        name: '監視カメラ',
        path: '/store-search/store-cctv',
        icon: 'cctv',
      }
    ],
    storeGroupList: [],
    cameraCount: {}, //uas = ai, uac = cctv 카메라 
    groupId: '',
	}),
  computed: {
    storeName() {
      let customerName = this.$store.getters.getStoreData.customerName;
      return customerName;
    },
    storeGroupData() {
      this.storeGroupList = this.$store.state.userData.storeGroupList;
      return this.storeGroupList;
    }
  },
	watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if(to.name == 'storeAnalyze') {
          this.currentRoute = '自店舗分析'
        } else if (to.name == 'otherStoreAnalyze') {
          this.currentRoute = '他店舗分析'
        } else {
          this.currentRoute = '監視カメラ'
        }
      }
    }
  },
	created() {
    this.authorities = this.$store.getters.getAuthorities;
		this.unisCustomerCd = this.$route.query.unisCustomerCd;
    // this.userSubscribedService = this.$store.getters.getUserSubscribedService;
    this.getCustomerContract();
    if(this.$route.query.groupId != undefined)
      this.groupId = this.$route.query.groupId;
  },
  mounted() {
    this.checkAuthNavItem();
    this.getStoreCameraCount();
  },
	methods: {
		goPush(path) {
      if(this.groupId != '')
        this.pushRoute(path, {unisCustomerCd: this.unisCustomerCd, groupId: this.groupId}); //매장 그룹에서 이동한 경우
      else
        this.pushRoute(path, {unisCustomerCd: this.unisCustomerCd});
    },
		goStoreGroup() {
      this.pushRoute('/store-group/create', {unisCustomerCd: this.unisCustomerCd});
    },
    async getCustomerContract() {
      let params = {};
      await this.networkController.getCustomerContract(params, this.unisCustomerCd)
      .then(async (res) => {
        this.storeData = res.data;
      }).catch(error => {});
    },
    checkAuthNavItem() {
      if(this.authorities.GET_STORE_GROUP == false) {
        let index = this.navItems.findIndex(r => r.name === '自店舗分析');
        this.navItems.splice(index, 1);
      }
      if(this.authorities.GET_RECORDING_SUB_BRANCH == false) {
        let index = this.navItems.findIndex(r => r.name === '監視カメラ');
        this.navItems.splice(index, 1);
      }
    },
    async addToGroup(item) {
      let storeList = item.stores;
      let duplicated = false;
			this.$vloading.show();
      storeList.forEach((i) => {
        if(i.unisCustomerCd == this.storeData.unisCustomerCd) {
          duplicated = true;
        }
      });
      if(duplicated) { //이미 그룹에 속해 있는 경우
				this.showToastMessage(this.tmb('storeAlreadyAdded'));
				this.$vloading.hide();
      } else {
        storeList.push({customerName : this.storeData.customerName, unisCustomerCd: this.storeData.unisCustomerCd});
			  let params = {
          groupName: item.groupName,
			  	stores: storeList,
			  };
			  await this.networkController.updateStoreGroup(params, item.id)
			  .then(async (res) => {
					this.showToastMessage(this.tmb('requestSuccess'));
				  this.$vloading.hide();
			  }).catch(error => {
					this.showToastMessage(this.tmb('requestFail'));
				  this.$vloading.hide();
			  });
      }
    },
    async getStoreCameraCount() {
      let params = {};
      await this.networkController.getStoreCameraCount(params, this.unisCustomerCd)
      .then(async (res) => {
        this.cameraCount = res.data;
      }).catch(error => {});
    }
	}
}
</script>

<style lang="scss" scoped>
#middle_divider {
	background-color: #4C4C4C;
}
#nav_list {
  background: #1D202C;
  border: none;
}
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__title{
    color: white;
  }
}
.current_route {
  color: white;
  background-color: rgba(225, 225, 225, 0.2);
  border-radius: 3px;
}
#store_detail_nav{
  position: sticky;
	top: 50px;
	z-index: 5;
  background: #1D202C;
  height: calc(100vh - 50px);
  min-height: 750px;
}
#menu_item {
  cursor: pointer;
	color: white;
}
#camera_box {
  background: #474C58;
  border-radius: 5px;
}
#camera_text_big {
  font-size: 2rem;
  font-weight: 500;
}
#camera_text_small {
  font-size: 0.8rem;
}
#camera_divider {
  color: #707070;
  border: 1px solid #707070;
  height: 3rem;
}
#info_text_small {
  font-size: 0.7rem;
}
#info_text_right {
  text-align: left;
  width: 4rem;
}
#info_text_left{
  text-align: left;
  width: 9.5rem;
}
</style>